import React, { useState, useEffect } from "react";
import Api from "../../components/api/Api";
import { Col, Container, Row } from "react-bootstrap";
import Notification, { showToast } from "../../../components/common/notification/Notification";
import { useNavigate, useParams } from "react-router-dom";
import Spinner from "../../../components/common/spinner/Spinner";
import SingleDetailHeader from "../../components/singleDetail/SingleDetailHeader";
import BreadCrumb from "../../components/breadcrumb/BreadCrumb";

const ViewCustomerLead = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [initialData, setInitialData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const getLeadApi = Api({
    url: `customer-lead/${id}`,
  });

  useEffect(() => {
    const fetchLead = async () => {
      try {
        if (id) {
          const response = await getLeadApi.fetchDataBySingleId();
          if (response && response.data && response.data.statusType === "SUCCESS") {
            setInitialData(response.data.customerLead);
          } else {
            showToast("Failed to fetch lead details", { type: "error" });
            navigate("/customer-lead");
          }
        }
      } catch (error) {
        console.error("Error fetching lead:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchLead();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const breadcrumbItems = [
    { label: "", link: "/admin", icon: "fa-solid fa-house" },
    { label: "Leads", link: "/customer-lead" },
    { label: "View Customer Lead", link: "", active: true },
  ];

  if (isLoading || !initialData) {
    return (
      <Container fluid style={{ marginTop: "2rem", display: "flex", justifyContent: "center" }}>
        <Spinner loading={true} />
      </Container>
    );
  }

  const customer = initialData.customer || {};

  return (
    <>
      <Notification />
      <Container fluid style={{ marginTop: "2rem", padding: "0rem 4rem" }}>
        <BreadCrumb items={breadcrumbItems} />
        <Row>
          <Col lg={12} md={12} sm={12}>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <SingleDetailHeader
                header="View Customer Lead"
                description={`View details for customer lead ID: ${id}`}
              />
              {/* Customer Leads might not have an edit page defined in App.js currently, 
                  so we omit the edit button or add it if it exists. */}
            </div>
            
            <div className="card p-4 shadow-sm border-0 mb-5" style={{ fontFamily: "'Inter', sans-serif" }}>
              <Row className="mb-4">
                <Col md={6}>
                  <h6 className="text-muted mb-1">Customer Name</h6>
                  <p className="fs-5">{customer.first_name} {customer.last_name}</p>
                </Col>
                <Col md={6}>
                  <h6 className="text-muted mb-1">Mobile Number</h6>
                  <p className="fs-5">{customer.mobile_number || "N/A"}</p>
                </Col>
              </Row>
              
              <Row className="mb-4">
                <Col md={6}>
                  <h6 className="text-muted mb-1">Email Address</h6>
                  <p className="fs-5">{customer.email_address || "N/A"}</p>
                </Col>
                <Col md={6}>
                  <h6 className="text-muted mb-1">Title</h6>
                  <p className="fs-5">{initialData.title || "N/A"}</p>
                </Col>
              </Row>

              <Row className="mb-4">
                <Col md={6}>
                  <h6 className="text-muted mb-1">Budget</h6>
                  <p className="fs-5">{initialData.budget || "N/A"}</p>
                </Col>
                <Col md={6}>
                  <h6 className="text-muted mb-1">City</h6>
                  <p className="fs-5">{initialData.city || "N/A"}</p>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <h6 className="text-muted mb-1">Purpose</h6>
                  <p className="fs-5">{initialData.purpose?.name || "N/A"}</p>
                </Col>
                <Col md={6}>
                  <h6 className="text-muted mb-1">Status</h6>
                  <span className={`badge fs-6 ${initialData.status === 'COMPLETED' ? 'bg-success' : 'bg-warning text-dark'}`}>
                    {initialData.status || "PENDING"}
                  </span>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ViewCustomerLead;
